(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('currencyFormatter', ['$rootScope', '$filter', function ($rootScope, $filter) {
			/**
			 * Auto currency formatter for input fields as user types
			 */
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {
					var isFr = $rootScope.lang == 'fr';

					//view to model
					ngModel.$parsers.push(function (value) {
						if (isFr) value = convertToEn(value);
						return clean(value);
					});

					//model to view
					ngModel.$formatters.push(function (value) {
						if (isFr) value = convertToFr(value);
						return formatCurrency(value);
					});

					element.bind('keyup change', function () {
						scope.$apply(onChange);
					});

					element.bind('blur', function () {
						var value = ngModel.$viewValue;
						if (value) {
							if (isFr) value = convertToEn(value);
							//if (value.match(/\.\d$/)) {
							//check if only 1 decimal place and change to 2
							//	value = value + "0";
							//} else if (value.match(/\.$/)) {
							if (value.match(/\.$/)) {
								//remove trailing .
								value = value.slice(0, -1);
							}
							if (isFr) value = convertToFr(value);
						}
						ngModel.$viewValue = value;
						ngModel.$render();
						ngModel.$commitViewValue();
					});

					function onChange() {
						ngModel.$viewValue = formatCurrency(ngModel.$viewValue);
						ngModel.$render();
						ngModel.$commitViewValue();
					}

					function formatCurrency(value) {
						if (!value) return value;
						value = value + "";
						if (isFr) value = convertToEn(value);
						//var hasTrailingDot = value.match(/\.$/) && (value.match(/\./g) || []).length == 1;
						value = clean(value);
						if (value) {
							//value = value.match(/^\d+(?:\.\d{0,2})?/)[0]; //truncate to 2 decimal places, no rounding!
							value = value.match(/^\d+/)[0];
							value = $filter('currencyFormat')(value, "en", true).replace(/\s?\$/, ''); //remove currency symbol
							//if (hasTrailingDot) value = value + ".";
						}

						if (isFr) value = convertToFr(value);
						return cleanNonCurrencyChars(value);
					}

					//always assumes input is in en
					function clean(value) {
						if (!value) return value;
						value = value.replace(/[^\d.]|\.\d{0,2}$/g, '');
						return value;
					}

					function cleanNonCurrencyChars(value) {
						if (!value) return value;
						value = value.replace(/[^\d,\s]/g, '');
						return value;
					}

					function convertToEn(value) {
						if (!value) return value;
						value = value + "";
						value = value.replace(",", ".");
						value = value.replace(/\s/g, ",");
						return value;
					}

					function convertToFr(value) {
						if (!value) return value;
						value = value + "";
						value = value.replace(/,/g, " ");
						//value = value.replace(".", ",");
						return value;
					}
				}
			}
		}]);

})();